var stringUtil = require('../string/stringUtil.js');
var validator = require('../validator/validator.js');
var constants = require('../domain/constants.js');
const localizationUtils = require('../localization/localizationUtils');

module.exports.convertToCurrencyFormat = function(value, treatEmptyAsZero)
{
    value = value + "";
    var numericValue = 0;
    if (stringUtil.isStringNullOrEmpty(value))
    {
        if (!treatEmptyAsZero)  
            return "";
            
        value = "0";
    }

    if (!validator.isNumeric(value))
        return "";

    numericValue = 1 * value;

    if (Math.abs(numericValue) <  constants.numericThresholdValue)
        numericValue = 0.0;

    return localizationUtils.getCurrentCurrencyFormatter().format(numericValue);
}

module.exports.convertToAmountFormat = function(value, treatEmptyAsZero)
{
    value = value + "";
    var numericValue = 0;
    if (stringUtil.isStringNullOrEmpty(value))
    {
        if (!treatEmptyAsZero)  
            return "";
            
        value = "0";
    }

    if (!validator.isNumeric(value))
        return "";

    numericValue = 1 * value;

    if (numericValue < constants.numericThresholdValue)
        numericValue = 0.0;

    return numericValue.toLocaleString(undefined, {minimumFractionDigits: 0, maximumFractionDigits: 2})
}

module.exports.roundUp = function (value, decimalPoints)
{
    if (!validator.isNumeric(value))
        return null;

    return  (value * 1).toFixed(decimalPoints) * 1;
}